import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationENG from "./en/translation.json";
import translationKOR from "./kr/translation.json";

const resources = {
  en: {
    translation: translationENG,
  },
  ko: {
    translation: translationKOR,
  },
};

const savedLang = localStorage.getItem("lang") || "ko";
i18n.use(initReactI18next).init({
  resources,
  lng: savedLang,
  fallbackLng: "ko",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
